module.exports = __webpack_public_path__ + "static/img/banner_xlh.798fbb19.jpg";